var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 3.5H26","stroke":"black","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M4 11.5H26","stroke":"black","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M4 19.5H20","stroke":"black","strokeWidth":"2","key":2})]);
}

BurgerMenu.defaultProps = {"width":"30","height":"23","viewBox":"0 0 30 23","fill":"none"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
